import { CodeNameModel } from 'components/common/types';
import { ProductIdentifier } from 'components/common/types/DirectSalesProductTemplate.types';
import { defaultAllFoldersProductOption } from './getProductsByFolderName';

export const mappedToCodeNameModel = (folderNames: string[]): CodeNameModel[] => {
  const folderNamesMapped = folderNames.map((folderName) => ({ code: folderName, name: folderName }));
  const allFolders = [defaultAllFoldersProductOption];

  return [...allFolders, ...folderNamesMapped];
};

export const getFolderNames = (products: ProductIdentifier[]): CodeNameModel[] => {
  const uniqueFolderNames = [...new Set(products.map(({ folder }) => folder))] as string[];

  return mappedToCodeNameModel(uniqueFolderNames);
};
